module.exports = __webpack_public_path__ + "img/mtbd.31330b5c.png";